import { render } from "./TheNodeTreeMenu.vue?vue&type=template&id=87535c16"
import script from "./TheNodeTreeMenu.vue?vue&type=script&lang=js"
export * from "./TheNodeTreeMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__